export const paths = {
  signin: "/signin",
  dashboard: "/dashboard",
  users: "/admin/users",
  userDetail: (userId = ":userId") => `/admin/users/${userId}`,
  roles: "/admin/roles",
  designations: "/admin/designations",
  hrDepartments: "/masters/departments",
  hrDesignations: "/masters/designations",
  hrTax: "/masters/tax",
  hrDeductions: "/masters/deductions",
  hrHolidays: "/masters/holidays",
  hrAreas: "/masters/areas",
  customers: "/masters/customers",
  customerNew: "/masters/customers/new",
  // custId is only branch-local, not globally unique (1,297 of 3,695 collide
  // across branches) - every single-customer route needs branchId too.
  customerEdit: (branchId = ":branchId", custId = ":custId") =>
    `/masters/customers/${branchId}/${custId}/edit`,
  customerGuarding: (branchId = ":branchId", custId = ":custId") =>
    `/masters/customers/${branchId}/${custId}/guarding`,
  customerBulkGuards: (branchId = ":branchId", custId = ":custId") =>
    `/masters/customers/${branchId}/${custId}/bulk-guards`,
  customerFieldVisits: (branchId = ":branchId", custId = ":custId") =>
    `/masters/customers/${branchId}/${custId}/field-visits`,
  customerLocationsMap: "/masters/customers/locations-map",
  products: "/masters/products",
  productGroups: "/masters/products/groups",
  productNew: "/masters/products/new",
  // productCode is only branch-local, not globally unique (2,087 of 3,288
  // collide across branches) - every single-product route needs branchId too.
  productEdit: (branchId = ":branchId", productCode = ":productCode") =>
    `/masters/products/${branchId}/${productCode}/edit`,
  employees: "/masters/employees",
  employeeNew: "/masters/employees/new",
  // Keyed by RecordGuid, not empId (switched server-side 2026-08-12,
  // Batch48_EmployeeBranchScopeFix.sql) - empId turned out not to be unique
  // even within one branch at real data volume (e.g. BranchId=1/empId=1310
  // matches 5 different real people). RecordGuid is the only genuinely
  // unique key, same convention as Vehicles/Stock.
  employeeEdit: (recordGuid = ":recordGuid") => `/masters/employees/${recordGuid}/edit`,
  employeePromote: (recordGuid = ":recordGuid") => `/masters/employees/${recordGuid}/promote`,
  feedback: "/admin/feedback",
  settings: "/admin/settings",
  vehicles: "/masters/vehicles",
  vehicleNew: "/masters/vehicles/new",
  // vehicleId is globally unique (unlike custId/productCode) - no branchId
  // needed in the route, same as Employee's empId.
  vehicleEdit: (vehicleId = ":vehicleId") => `/masters/vehicles/${vehicleId}/edit`,

  // Stock Management - own top-level module (not nested under masters),
  // built against TexasAlarms.Api's src/Stock module. LPO/Stock-In/Stock-Out/
  // Return/Adjustment records are keyed by a globally-unique RecordGuid
  // (like Vehicles), so none of these routes need a {branchId} composite key.
  stockLpos: "/stock/lpos",
  stockLpoNew: "/stock/lpos/new",
  stockLpoEdit: (recordGuid = ":recordGuid") => `/stock/lpos/${recordGuid}/edit`,
  stockLpoDetail: (recordGuid = ":recordGuid") => `/stock/lpos/${recordGuid}`,
  stockLpoPendingVehicleRequests: "/stock/lpos/pending-vehicle-requests",
  stockIn: "/stock/stock-in",
  stockInNew: "/stock/stock-in/new",
  stockInDetail: (recordGuid = ":recordGuid") => `/stock/stock-in/${recordGuid}`,
  stockOut: "/stock/stock-out",
  stockOutNew: "/stock/stock-out/new",
  stockOutDetail: (recordGuid = ":recordGuid") => `/stock/stock-out/${recordGuid}`,
  stockReturns: "/stock/returns",
  stockReturnNew: "/stock/returns/new",
  stockReturnDetail: (recordGuid = ":recordGuid") => `/stock/returns/${recordGuid}`,
  stockAdjustments: "/stock/adjustments",
  stockAdjustmentNew: "/stock/adjustments/new",
  stockAdjustmentDetail: (recordGuid = ":recordGuid") => `/stock/adjustments/${recordGuid}`,
  stockBalances: "/stock/balances",
};
